// ▶ O que o botao do card da lista de produtos oferece, e o que ele PERGUNTA
// antes de fazer.
//
// Pedido dela em 02/09: "produto sem preco tem que ficar sinalizado na tela de
// produtos para o vendedor inativar, caso esteja sem preco por nao ter pra
// venda". O AVISO ja existia ("Sem preco cadastrado", em ambar); o que faltava
// era a ACAO -- hoje, para tirar um produto de circulacao, ela abre a ficha,
// rola ate o fim e desmarca a caixinha.
//
// Por que a pergunta mora aqui e nao na tela: a tela nao roda no vitest, e a
// regra que mais importa e justamente a da pergunta -- ela tem de dizer o NOME
// do produto. A lista e rolada com o polegar dentro do carro, e uma pergunta
// generica ("Tem certeza?") nao deixa a pessoa perceber que o dedo pegou o card
// errado. Um toque errado tira o produto da busca do pedido na hora.
export interface AcaoDoCard {
  rotulo: string
  pergunta: string
  novoAtivo: boolean
}

// Produto sem descricao existe: a importacao aceita linha com o campo em
// branco. `Tirar "" de circulacao?` seria uma pergunta sobre nada.
function comoChamar(descricao: string): string {
  const nome = descricao.trim()
  return nome === '' ? 'este produto' : `"${nome}"`
}

export function acaoDoCard(produto: { descricao: string; ativo: boolean }): AcaoDoCard {
  const nome = comoChamar(produto.descricao)
  if (produto.ativo) {
    return {
      rotulo: 'Inativar',
      // A CONSEQUENCIA, e nao so o ato: "inativar" nao quer dizer nada para quem
      // esta vendendo; "sai da busca do pedido" quer.
      pergunta: `Tirar ${nome} de circulação? Ele deixa de aparecer na busca do pedido.`,
      novoAtivo: false,
    }
  }
  return {
    rotulo: 'Reativar',
    pergunta: `Voltar a vender ${nome}? Ele volta a aparecer na busca do pedido.`,
    novoAtivo: true,
  }
}
